import React from 'react';

const Account = React.lazy(() => import('views/account').then(m => ({ default: m.Account })));
const Profile = React.lazy(() => import('views/account/profile').then(m => ({ default: m.Profile })));
const Billing = React.lazy(() => import('views/account/billing').then(m => ({ default: m.Billing })));
const Upgrade = React.lazy(() => import('views/account/upgrade').then(m => ({ default: m.Upgrade })));
const Users = React.lazy(() => import('views/account/users').then(m => ({ default: m.Users })));
const Password = React.lazy(() => import('views/account/password').then(m => ({ default: m.Password })));
const TwoFA = React.lazy(() => import('views/account/2fa').then(m => ({ default: m.TwoFA })));
const APIKeyList = React.lazy(() => import('views/account/apikey/list').then(m => ({ default: m.APIKeyList })));
const APIKeyEditor = React.lazy(() => import('views/account/apikey/edit').then(m => ({ default: m.APIKeyEditor })));
const Coordinators = React.lazy(() => import('views/coordinator/coordinators').then(m => ({ default: m.Coordinators })));

const Routes = [
  {
    path: '/account',
    view: Account,
    layout: 'app',
    permission: 'user',
    title: 'Mi cuenta'
  },
  {
    path: '/account/profile',
    view: Profile,
    layout: 'app',
    permission: 'user',
    title: 'Tu perfil'
  },
  {
    path: '/account/password',
    view: Password,
    layout: 'app',
    permission: 'user',
    title: 'Cambiar contraseña'
  },
  {
    path: '/account/2fa',
    view: TwoFA,
    layout: 'app',
    permission: 'user',
    title: 'Factor de doble autentificación'
  },
  {
    path: '/account/billing',
    view: Billing,
    layout: 'app',
    permission: 'owner',
    title: 'Facturación'
  },
  {
    path: '/account/upgrade',
    view: Upgrade,
    layout: 'app',
    permission: 'owner',
    title: 'Mejorar Plan'
  },
  {
    path: '/account/users',
    view: Users,
    layout: 'app',
    permission: 'admin',
    title: 'Usuarios'
  },
  {
    path: '/account/coordinators',
    view: Coordinators,
    layout: 'app',
    permission: 'admin',
    title: 'Coordinadores'
  },
  {
    path: '/account/apikeys',
    view: APIKeyList,
    layout: 'app',
    permission: 'developer',
    title: 'Claves de API'
  },
  {
    path: '/account/apikeys/create',
    view: APIKeyEditor,
    layout: 'app',
    permission: 'developer',
    title: 'Claves de API'
  },
  {
    path: '/account/apikeys/edit',
    view: APIKeyEditor,
    layout: 'app',
    permission: 'developer',
    title: 'Claves de API'
  },
]

export default Routes;
